<template>
  <a role="button" class="text-red-600 text-sm" @click="showRemoveMemberDialog">Remove</a>
</template>

<script>
export default {
  props: {
    membership: {
      type: Object,
      required: true,
    },
  },
  methods: {
    showRemoveMemberDialog() {
      this.$modal.show({
        component: () => import('./RemoveMemberDialog.vue'),
        props: {
          membership: this.membership,
        },
        on: {
          removed: () => {
            this.$emit('removed');
          },
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
